import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { teseService } from "@/services/teseService";
import type { TeseCreatePayload, TeseUpdatePayload } from "@/types/tese";

const keys = {
  list: (onlyActive?: boolean) => ["teses", onlyActive ?? "all"] as const,
  one: (id: number) => ["teses", "one", id] as const,
};

export function useTeses(onlyActive?: boolean, enabled = true) {
  return useQuery({
    queryKey: keys.list(onlyActive),
    queryFn: () => teseService.list(onlyActive ? { only_active: true } : undefined),
    enabled,
  });
}

export function useCreateTese() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload: TeseCreatePayload) => teseService.create(payload),
    onSuccess: () => void qc.invalidateQueries({ queryKey: ["teses"] }),
  });
}

export function useUpdateTese() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: TeseUpdatePayload }) =>
      teseService.update(id, payload),
    onSuccess: () => void qc.invalidateQueries({ queryKey: ["teses"] }),
  });
}

export function useDeleteTese() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => teseService.remove(id),
    onSuccess: () => void qc.invalidateQueries({ queryKey: ["teses"] }),
  });
}
